module.exports = __webpack_public_path__ + "img/定位-枢源总部.d4e4c4d0.svg";